import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { WebMerchantUrlsDto } from './web-merchant-urls.dto';
export class WebStoreUrlsDto extends WebMerchantUrlsDto {
}
__decorate([
    Expose(),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], WebStoreUrlsDto.prototype, "menu", void 0);
__decorate([
    Expose(),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], WebStoreUrlsDto.prototype, "profile", void 0);
__decorate([
    Expose(),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], WebStoreUrlsDto.prototype, "login", void 0);
__decorate([
    Expose(),
    ApiProperty({ type: () => String }),
    __metadata("design:type", String)
], WebStoreUrlsDto.prototype, "placePickerRedirectToUrl", void 0);
__decorate([
    Expose(),
    ApiPropertyOptional({ type: () => String }),
    __metadata("design:type", String)
], WebStoreUrlsDto.prototype, "unsubscribeUrl", void 0);
//# sourceMappingURL=web-store-urls.dto.js.map